import React from 'react'
import ResponsiveContainer from './components/ResponsiveContainer';






const Homepage = ({children,heading}) => (
    <ResponsiveContainer heading={heading}>
        {children}
    </ResponsiveContainer>
);


export default Homepage


// WEBPACK FOOTER //
// ./src/components/Homepage/index.js